<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row flex">
            <div class="vx-col w-5/12 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.project')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.project") }}*</label>
                <v-select v-model="form.project" :clearable="true" :options="projectsOptions" :reduce="res => res.value" name="project" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex">
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="form.nameTh" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameEn')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameEn") }}</label>
                <vs-input type="text" v-model="form.nameEn" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.master.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.master.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import {IStatus} from "@/constants/interface";

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        project: '',
        nameTh: '',
        nameEn: '',
        status: IStatus.enabled,
      }
    }
  },
  async created () {
    const vm = this
    const { getProjectOptions, getCampus } = vm
    await getProjectOptions()
    await getCampus({form: {id: vm.$route.params.id}})
    vm.pms ('MasterCampus', 'edit', 'r')
    vm.reset ()
  },
  computed: {
    ...mapMasterFields(['status', 'campus']),
    ...mapGetters({
      statusesOptions :'Master/statusesOptions',
      projectsOptions: "Master/projectOptions",
    })
  },
  methods: {
    ...mapMasterActions(['getCampus', 'updateCampus', 'getProjectOptions']),
    async submit () {
      const vm = this
      const { updateCampus } = vm
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        updateCampus({
          id: vm.$route.params.id,
          form: {
            project:  {id: vm.form.project || ''},
            nameTh: vm.form.nameTh,
            nameEn: vm.form.nameEn,
            status: vm.form.status,
          },
          vm,
          redirect: "/master/campus"
        })
      })
    },
    reset () {
      const vm = this

      const project = (vm.campus.projectId ? vm.campus.projectId : '')

      vm.form = {
        project,
        nameTh: vm.campus.nameTh,
        nameEn: vm.campus.nameEn,
        status: vm.form.status,
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
